export default {"src":"/login-app/[GIT_HASH]/_next/static/media/splitscreen.1b11bc56.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};